/* eslint-disable array-callback-return */
import NotificationAlert from "../../components/notification";
import SideMenu from "../sideMenu";
import DashboardHeader from "../topbar";
import Styles from "./styles.module.scss";
import {checkAvailabilitymixpanel, makeSideBarActive } from "../../utils/EllowUtils";
import * as CONSTANTS from "../../utils/CONSTANTS";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Resume from "./resume";
import PersonalDetails from "./personalDetails";
import Preview from '../../common/resumePreview/preview';
import { getDetails, submitProfile, sendCredentails, updateProfiles, applyCandidateToJob } from "./services";
import ConfirmationModal from "../../modal/confirmation/confirmationModal";
import mixpanelData, { userProfile, viewedpageMixpanel } from "../../utils/mixpanel";
import { getAPI } from "../../api";

function CreateResource() {

   const customerId = localStorage.getItem('customerId')
  const menu = makeSideBarActive(CONSTANTS.sideMenu, 1);
  const BreadcrumsValues = ["Resources", "Create New Resources"];
  const selectedCandidates =  localStorage.getItem('selectedCandidates') ? JSON.parse(localStorage.getItem('selectedCandidates') || '') || '' : ''
  const [notification, setNotification] = useState<boolean>(false);
  const location: any = useLocation();
  const navigate = useNavigate()
  const select: any = location.state ? location.state : {};
  const selector : number  = select.selector ? select.selector : 0
  const [type, setType] = useState<any>("success");
  const [icon, setIcon] = useState<boolean>(true);
  const [message, setMessage] = useState<string>("");
  const [selected, setSelected] = useState<boolean>(false);
  const [resume, setResume] = useState<string | null>(null);
  const candidateLoginId: any = select.candidateLoginId || "";
  const [loginId, setLoginId] = useState<any>(candidateLoginId);
  const userLoginId = localStorage.getItem("loginId");
  const[profileSubmitted, setProfileSubmitted] = useState<boolean>(false)
  const [profileValues, setProfileValues] = useState<{ firstName?: string; lastName?: string; email?: string; phoneNumber?: string; nationality?: string; country?: string; workExp: number; positionName: string; jobRole: any; }>({ firstName: '', lastName: '', email: '', phoneNumber: '', workExp:0, positionName:'', jobRole: {}})
  const availId = localStorage.getItem('availableId')
  const {  tab }: any = location.state || ''
  const [candidateStatus, setCandidateStatus] = useState<number>()
  const [allData, setAllData] = useState<any>()
  const [disableProfileButton , setDisableProfileButton] = useState<boolean>(false)
  const [resumeError, setResumeError] = useState<string>('')
  const [availabilityValues, setAvailabilityValues] = useState({
    availability: {
      availabilityId: '',
      date: "",
      weeks:''
    }
  })
  const jobId = select.jobId || ''
  const positionName = select.positionName || ''
  const companyName = select.companyName || ''
  const [confirmationModal, setConfirmationModal] = useState<boolean>(false)
  const [tempData, setTempData] = useState<any>()
  const customerMetadata = JSON.parse(localStorage.getItem('customerMetdata') || '') || ''
 const [jobRoleList, setJobRoleList] = useState<any>()

    useEffect(() => {
    
      if (candidateLoginId && candidateLoginId !== '') {
        getUserDetails(candidateLoginId);  
      }
      
      if(tab){  
        setSelected(false)
      }
      else {
        setSelected(true)
      }
      
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [availId, selector])
  
  useEffect(() => {
    viewedpageMixpanel()

    getAPI('https://api.ellow.io/common/api/v1/ml/job-roles').then((value: any) => {
      if (value && value.status === 1) {
        setJobRoleList(value.data)
      }
    })

   }, [])

  const getUserDetails = (id: string | null) => { 
    getDetails(id).then((response: any) => {
      if (response && response.status === 1) {
        if (response.data[0].candidate_status > 1) {
          setProfileSubmitted(true)
        }
        localStorage.setItem("profile_metadata", JSON.stringify(response.data[0].profile_metadata))
        setLoginId(response.data[0].login_id)
        setCandidateStatus(response.data[0].candidate_status)
        setResume(response.data[0].resume_file_name) 
        setAllData(response.data[0].profile_metadata)
         
        localStorage.setItem("profile_metadata", JSON.stringify(response.data[0].profile_metadata))
                              
          let porofDetails = {
            country: response.data[0].profile_metadata.country,
            email: response.data[0].profile_metadata.email,
            firstName: response.data[0].profile_metadata.firstName,
            lastName: response.data[0].profile_metadata.lastName,
            nationality: response.data[0].profile_metadata.nationality,
            phoneNumber: response.data[0].profile_metadata.phoneNumber && response.data[0].profile_metadata.phoneNumber.toString() ? response.data[0].profile_metadata.phoneNumber.toString() : '',
            jobRole: response.data[0].profile_metadata.jobRoles,
            positionName: response.data[0].profile_metadata.positionName,
            workExp: response.data[0].profile_metadata.workExperience,
            salary: response.data[0].profile_metadata.preference &&  response.data[0].profile_metadata.preference.salary,
            billingType: response.data[0].profile_metadata.preference && response.data[0].profile_metadata.preference.salary.billingType,
            currencyType: response.data[0].profile_metadata.preference && response.data[0].profile_metadata.preference.salary.currencyType,
            expectedPay: response.data[0].profile_metadata.preference && response.data[0].profile_metadata.preference.salary.expectedPay

          } 
          setProfileValues(porofDetails)
          availabilityValues.availability = response.data[0].profile_metadata.availability
          setAvailabilityValues({...availabilityValues}) 
       }
      }
    )
  };

  const displayNotification = (message: string) => {
    setMessage(message)
    setNotification(true)
    setTimeout(() => {
       setNotification(false)
     }, 3000);
 }

  const updateProfileValues = (data: any, body?: any) => {
     
   
    let values = {
      loginId: loginId ? loginId : localStorage.getItem('candidateLoginId') ,
      userLoginId: userLoginId,
      submittedBy: 'PROVIDER',
      profileMetadata: data,
      behalfOf: customerId,
      status: 'true',
      candidateStatus: candidateStatus && candidateStatus === 1 ? '2' : candidateStatus && candidateStatus.toString(),
      sourcedBy: "PROVIDER",
     }
    if (resume) {
      if(data !== undefined && data.firstName){
        setDisableProfileButton(true)
      } 
      updateProfiles(values).then((response: any) => {
        if (response && response.status === 1) {
          setLoginId(response.data[0].login_id)
          localStorage.setItem('candidateLoginId', response.data[0].login_id)
          localStorage.setItem("profile_metadata", JSON.stringify(response.data[0].profile_metadata))
          localStorage.setItem('availablityId', response.data[0].profile_metadata && response.data[0].profile_metadata.availability && response.data[0].profile_metadata.availability.availabilityId)

          if (response.data[0].profile_metadata && response.data[0].profile_metadata.availability && response.data[0].profile_metadata.availability.availabilityId === 2) {
            localStorage.setItem('date', response.data[0].profile_metadata.availability.date)
          }
          if (response.data[0].profile_metadata && response.data[0].profile_metadata.availability && response.data[0].profile_metadata.availability.availabilityId === 3) {
            localStorage.setItem('weeks', response.data[0].profile_metadata.availability.date)
          }
          
          if (!candidateLoginId && jobId) {
            
            let ids: any; 
            if (selectedCandidates && selectedCandidates.length > 0) {
              ids = selectedCandidates && selectedCandidates.length > 0 && selectedCandidates.map((item: any) => {
              return item.loginId
            })
              ids.push(loginId)
            }

            let applyCandidateValue = {
              userLoginId: userLoginId,
              loginId: selectedCandidates && selectedCandidates.length > 0 ? ids : [loginId],
              jobId: jobId
            }
            applyCandidateToJob(applyCandidateValue).then((response) => {
              if (response && response.status === 1) {
                mixpanelData('New ML - New Profile submitted ', {
                  'distinct_id': localStorage.getItem('Email') ,
                  'Candidate name' : data.firstName + ' ' + data.lastName,
                  'Candidate loginid': values.loginId,
                  'Candidate email': data.email,
                  'Resume name': resume,
                  'Phone number': data.phoneNumber,
                  'Experience': data.workExperience + ' Years',
                  'Job role': data.jobRoles && data.jobRoles.length > 0 && data.jobRoles.map((item: any) => item.name),
                  'Designation': data.positionName,
                  'Expected pay': data.preference.salary.expectedPay + ' ' + data.preference.salary.currencyType + '/' +  data.preference.salary.billingType
                })
                userProfile({
                  '$name': data.firstName + " " + data.lastName,
                  '$email': data.email,
                  '$phone': data.phoneNumber,
                  'Experience': data.workExperience,
                  'Job role': data.jobRoles && data.jobRoles.length > 0 && data.jobRoles.map((item: any) => item.name),
                  'Designation': data.positionName,
                  'Expected pay': data.preference.salary.expectedPay + ' ' + data.preference.salary.currencyType + '/' +  data.preference.salary.billingType
                }, values.loginId)

                if (selectedCandidates && selectedCandidates.length < 1) {
                  mixpanelData('New ML - Candidate applied', {
                    'distinct_id': localStorage.getItem('Email') ,
                    'Candidate name': response && response.data.candidateDetails[0].CandidateName,
                    'Candidate email': response && response.data.candidateDetails[0].candidateEmail,
                    'Phone number': response && response.data.candidateDetails[0].phoneNumber,
                    'Candidate experience': response && response.data.candidateDetails[0].experience + ' Years',
                    'Job role': response && response.data.jobDetails[0].JobRole.name,
                    'Expected pay': response && response.data.candidateDetails[0].expectedPay + ' ' + response.data.candidateDetails[0].currencyType + '/' + response.data.candidateDetails[0].billingType,
                    'Submitted by': response && response.data.candidateDetails[0].submittedUserName,
                    'JobId': response && response.data.jobDetails[0].jobId,
                    'Position name': response && response.data.jobDetails[0].position,
                    'Company name': response && response.data.jobDetails[0].companyName,
                    'Candidate loginid': values.loginId,
                    'Job type': response && response.data.jobDetails[0].jobType,
                  })
                }
                else {
                  ids && ids.length > 0 && ids.map((item: any, key: number) => {
                    mixpanelData('New ML - Candidate applied', {
                      'distinct_id': localStorage.getItem('Email') ,
                      'Candidate name': response && response.data.candidateDetails[key].CandidateName,
                      'Candidate email': response && response.data.candidateDetails[key].candidateEmail,
                      'Phone number': response && response.data.candidateDetails[key].phoneNumber,
                      'Candidate experience': response && response.data.candidateDetails[key].experience + ' Years',
                      'Job role': response && response.data.jobDetails[0].JobRole.name,
                      'Expected pay': response && response.data.candidateDetails[key].expectedPay + ' ' + response.data.candidateDetails[key].currencyType + '/' + response.data.candidateDetails[key].billingType,
                      'Submitted by': response && response.data.candidateDetails[key].submittedUserName,
                      'Job id': response && response.data.jobDetails[0].jobId,
                      'Job type': response && response.data.jobDetails[0].jobType,
                      'Position name': response && response.data.jobDetails[0].position,
                      'Company name': response && response.data.jobDetails[0].companyName,
                      'Candidate loginid': item,
                      'Provider company name': customerMetadata && customerMetadata.companyName
                    })
                  })
                   }          
                
                setMessage('Profile applied to position successfully')
                  setNotification(true)
                  setType('success')
                  setIcon(true)
                  setTimeout(() => {
                    setNotification(false)
                    navigate('/position-details', { state: { jobId: jobId, positionName: positionName, companyName: companyName}})
                    setDisableProfileButton(true)
                    localStorage.removeItem("selectedCandidates");
                  }, 3000);
              }
            })
          }
          else {
            mixpanelData('New ML - profile Edited', {
              'distinct_id': localStorage.getItem('Email') ,
              'Candidate name' : data.firstName + ' ' + data.lastName,
              'Candidate loginid': values.loginId,
              'Candidate email': data.email,
              'Resume name': resume,
              'Phone number': data.phoneNumber,
              'Experience': data.workExperience + ' Years',
              'Job role': data.jobRoles && data.jobRoles.length > 0 && data.jobRoles.map((item: any) => item.name),
              'Designation': data.positionName,
              'Expected salary': data.preference.salary.expectedPay + ' ' + data.preference.salary.currencyType + '/' +  data.preference.salary.billingType
            })
            userProfile({
              '$name': data.firstName + ' ' + data.lastName,
              '$email': data.email,
              '$phone': data.phoneNumber,
              'Work experience': data.workExperience,
              'Job role': data.jobRoles && data.jobRoles.length > 0 && data.jobRoles.map((item: any) => item.name),
              'Designation': data.positionName,
              'Expected salary': data.preference.salary.expectedPay + ' ' + data.preference.salary.currencyType + '/' +  data.preference.salary.billingType
            }, values.loginId)
            setMessage('Details saved successfully')
            setSelected(false)
            setNotification(true)
            setType('success')
            setIcon(true)
            setDisableProfileButton(false)
            getUserDetails(response.data[0].login_id)
            setTimeout(() => {
            setNotification(false)
          }, 3000);
          }
          
        } else {
          setType('error')
          setIcon(false)
          displayNotification('Found Duplicate EmailId')
          setDisableProfileButton(false)
        }
      })
    }
    else {
      setType('error')
      setIcon(false)
      displayNotification('Upload resume before submitting')
      window.scrollTo(0, 0);
      setResumeError('Required*')
    }
  }

  const submitCheck = (value: boolean, data: any) => {
    console.log(data)
    const profileMetadata: any = JSON.stringify(localStorage.getItem('profile_metadata') || '')
    if (!value) {
      submitProfile(data).then((response: any) => {
        if (response && response.status === 1) {
          mixpanelData('ML-Full Profile submitted', {
            'source': 'Provider submits profile',
            'distinct_id': localStorage.getItem('Email'),
            'Candidate name': profileMetadata && profileMetadata.firstName + " " + profileMetadata.lastName,
            'candidate email': profileMetadata && profileMetadata.email,
            'candidate phone number': profileMetadata && profileMetadata.phoneNumber,
            'work experience': `${profileMetadata && profileMetadata.workExperience} years`,
            'country': profileMetadata && profileMetadata.country,
            'designation': profileMetadata && profileMetadata.designation,
            'jobRoles': profileMetadata && profileMetadata.jobRoles && profileMetadata.jobRoles.length > 0 && profileMetadata.jobRoles.map((item: any) => item.name),
            'Nationality': profileMetadata && profileMetadata.nationality,
            'Expected pay': profileMetadata && profileMetadata.preference && profileMetadata.preference.salary && `${profileMetadata.preference.salary.expectedPay} ${profileMetadata.preference.salary.currencyType} / ${profileMetadata.preference.salary.billingType}`,
            'Availability': profileMetadata && profileMetadata.availability && checkAvailabilitymixpanel(profileMetadata.availability.availabilityId, profileMetadata.availability.availabilityId === 1 ? profileMetadata.availability.date : profileMetadata.availability.weeks),
            
          })
          setLoginId(response.data[0].login_id)
          getUserDetails(response.data[0].login_id);
          localStorage.setItem('candidateLoginId', response.data[0].login_id)
          setMessage('Profile Submitted Successfully')
          setNotification(true)
          setType('success')
          setType(true)
          setTimeout(() => {
             setNotification(false)
           }, 3000);
        }
     })
    }
  }

  const sentCredentials = () => {
    let data = {
        "loginId":loginId,
        "userLoginId":userLoginId
    }
    sendCredentails(data).then((response) => {
      if (response && response.status === 1) {
        setType('success')
        setIcon(true)
      }
      if (response && response.status === '2') {
        setType('error')
        setIcon(false)
      }
      getUserDetails(candidateLoginId); 
      displayNotification(response.message)
    })
  }
  
  const CheckFunction = (data: any) => {
    if (profileSubmitted && (!jobId || jobId === '')) {
     updateProfileValues(data)
    }
    
    else {
      if(resume){
        setConfirmationModal(true)
        setTempData(data)
      }else{
        setResumeError('Required*')
      }
    }
}

  const onClose = () => {
    setConfirmationModal(false)    
  }

  return (
    <section className="dashboardWrapper">
      <SideMenu menu={menu} />

      <div className="dashboardContent">
        <DashboardHeader searchChange={undefined} title={BreadcrumsValues}  />

        {notification && (
          <NotificationAlert
            onClose={() => setNotification(false)}
            closable={true}
            type={type}
            icon={icon}
          >
            {message}
          </NotificationAlert>
        )}
        {confirmationModal && <ConfirmationModal submit={() => { updateProfileValues(tempData); setConfirmationModal(false) }} onClose={onClose} jobRole={select.positionName} apply={[]}/>}
        <div className={Styles.profile}>
          {selected ? 
            <div  className={Styles.profileBody}>
              <Resume loginId={loginId} getUserDetails={getUserDetails} resume={resume} userLoginId={userLoginId} resumeError={resumeError} />
              <PersonalDetails ClickHandler={CheckFunction} defaultValues={profileValues} disable={disableProfileButton} profileSubmitted={profileSubmitted} jobRolesList={jobRoleList} />  
          </div>    
            :
            <div  className={Styles.profileBody}>
              <Preview showSubmit={true} candaidateData={allData} profileSubmitted={profileSubmitted} submitCheck={submitCheck} editClick={() => setSelected(true)} loginId={loginId} sentCredentails={sentCredentials} />
            </div>  
          }
        </div>
      </div>
    </section>
  )
          }

  export default CreateResource
